// Réalisations affichées sur l'accueil. Seules les fiches avec publie: true sont visibles ;
// la section est masquée tant qu'aucune n'est publiée.
export const REALISATIONS = [
  {
    publie: false,
    titre: "EXEMPLE – à remplacer : Résidence de 48 logements",
    typeBatiment: "Copropriété",
    ville: "Rennes (35)",
    ancienneEnergie: "Gaz",
    surface: "48 logements",
    puissancePac: "160 kW",
    primeCee: 95000,
    resteACharge: 0,
    economieAnnuelle: "≈ 45 %",
    photoAvant: "https://images.unsplash.com/photo-1692119442094-45806e38a35e?w=800&q=70",
    photoApres: "https://images.unsplash.com/photo-1776860154052-d91c90b25c59?w=800&q=70",
  },
  {
    publie: false,
    titre: "EXEMPLE – à remplacer : EHPAD de 80 lits",
    typeBatiment: "EHPAD",
    ville: "Vannes (56)",
    ancienneEnergie: "Fioul",
    surface: "3 000 m²",
    puissancePac: "200 kW",
    primeCee: 70000,
    resteACharge: 0,
    economieAnnuelle: "≈ 50 %",
    photoAvant: "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=800&q=70",
    photoApres: "https://images.unsplash.com/photo-1773227059784-c1e36cc8c8c9?w=800&q=70",
  },
  {
    publie: false,
    titre: "EXEMPLE – à remplacer : Immeuble de bureaux",
    typeBatiment: "Bureaux",
    ville: "Nantes (44)",
    ancienneEnergie: "Gaz",
    surface: "2 000 m²",
    puissancePac: "120 kW",
    primeCee: 50000,
    resteACharge: 0,
    economieAnnuelle: "≈ 40 %",
    photoAvant: "https://images.unsplash.com/photo-1709497197725-2e97c76b31d0?w=800&q=70",
    photoApres: "https://images.unsplash.com/photo-1568992688065-536aad8a12f6?w=800&q=70",
  },
];
